import { generateCompleteFileName } from 'utils/fileNameGenerator'

export const arrayToCsv = data => {
  // Ensure data is valid and filter out any null/undefined items
  if (!Array.isArray(data)) {
    console.warn('arrayToCsv: data is not an array', data)
    return
  }

  const validData = data.filter(item => item != null)

  if (validData.length === 0) {
    console.warn('arrayToCsv: no valid data to export')
    return
  }

  const headers = [
    'Name',
    'Report Status',
    'Business Form',
    'Data Sources',
    'Industry',
    'Address',
    'Owners',
    'TIN',
    'Locations',
    'Employees',
    'Marketing Spending',
    'Documented',
    'Reported',
    'Number of Visitors',
    'Number of Reviews',
    'Untaxed Revenue',
  ]

  const rows = validData.map(item => {
    return {
      Name: item.businessName || 'N/A',
      'Report Status': (() => {
        const reportedStatusArray = []

        if (item.reportedStatus && typeof item.reportedStatus === 'object') {
          Object.keys(item.reportedStatus).forEach(key => {
            reportedStatusArray.push(`${key}: ${item.reportedStatus[key]}`)
          })
        }

        return reportedStatusArray.join(', ')
      })(),
      'Business Form': item.businessStructure || 'N/A',
      'Data Sources': (() => {
        if (!item.websiteLinks || Object.keys(item.websiteLinks).length === 0) return 'N/A'

        const dataSourcesArray = []
        Object.keys(item.websiteLinks).forEach(key => {
          const linkArray = item.websiteLinks[key]
          if (Array.isArray(linkArray)) {
            dataSourcesArray.push(linkArray.join(', '))
          }
        })

        return dataSourcesArray.join(', ')
      })(),
      Industry: (() => {
        if (!item.businessType) return 'N/A'

        if (Array.isArray(item.businessType)) {
          if (item.businessType.length === 0) return 'N/A'

          return item.businessType[0]
        }

        return item.businessType
      })(),
      Address: item.businessAddresses?.join(', ') || 'N/A',
      Owners:
        item.businessOwner
          ?.map(owner => owner?.name)
          .filter(name => name)
          .join(', ') || 'N/A',
      TIN: item.tin || 'N/A',
      Locations: `${item.listings?.currentZone || 0} / ${item.listings?.total || 0}`,
      Employees: `${item.employees?.currentZone || 0} / ${item.employees?.total || 0}`,
      'Marketing Spending': item.marketingEfforts || '',
      Documented: `${typeof item.documentedIncome === 'number' ? item.documentedIncome : 'N/A'}`,
      Reported: `${typeof item.reportedIncome === 'number' ? item.reportedIncome : 'N/A'}`,
      'Number of Visitors': item.numberOfVisitors || 'N/A',
      'Number of Reviews': `${typeof item.reviewsCount === 'number' ? item.reviewsCount : 'N/A'}`,
      'Untaxed Revenue': `$${item.untaxedIncome || 0}`,
    }
  })

  const csvContent = [
    headers.join(','),
    ...rows.map(row => headers.map(header => JSON.stringify(row[header] || '')).join(',')),
  ].join('\n')

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.setAttribute('href', url)

  const fileName = generateCompleteFileName({
    vertical: 'Businesses',
    exportType: 'main',
  })
  link.setAttribute('download', `${fileName}.csv`)

  link.style.visibility = 'hidden'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
